<template>
  <div>
    <iframe
      width="100%"
      height="1000px"
      :src="
        isFranchiseOrHigher
          ? 'https://lookerstudio.google.com/embed/reporting/b9c519de-ec59-491e-902e-d22a4f2dba08/page/p_ca91o4pj2c'
          : 'https://lookerstudio.google.com/embed/reporting/0dd88a24-0525-4bd7-b612-a3b745ce8ac8/page/p_ca91o4pj2c'
      "
      frameborder="0"
      style="border: 0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isNotCommonUser } from "@/constants/consultants";
import * as accountTypes from "@/modules/account/store/types";
export default {
  computed: {
    ...mapGetters({
      user: accountTypes.USER,
    }),
    isFranchiseOrHigher() {
      return isNotCommonUser(this.user?.user_role_id);
    },
  },
};
</script>
